import { brandName } from "@/constants/brand";
import type { LocationQueryValue } from "vue-router";

export type MetaTagProps = {
  id: string;
  name: string;
  content: string;
};

export function createMetaDataLink(linkProps: Record<string, string>): void {
  const linkMeta = document.createElement("link");
  const existingLink = document.getElementById("meta-link");

  existingLink?.remove();

  linkMeta.id = linkProps.id;
  linkMeta.rel = linkProps.rel;
  linkMeta.href = linkProps.href;
  linkMeta.type = linkProps.type;

  document.head.appendChild(linkMeta);
}

export function createMetaData(
  metaProps: MetaTagProps[],
  theme: string | LocationQueryValue[],
): void {
  const title =
    theme === "covomo" ? `${brandName} Vergleichsrechner` : "Vergleichsrechner";

  const headTitle = document.querySelector("title");

  if (headTitle) {
    headTitle.textContent = title;
  }

  metaProps.forEach((prop) => {
    document.getElementById(prop.id)?.remove();

    const metaTag = document.createElement("meta");

    metaTag.id = prop.id;
    metaTag.name = prop.name;
    metaTag.content = prop.content;

    document.head.appendChild(metaTag);
  });
}
